module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('div', {
    staticClass: "bg-linear"
  }), _vm._v(" "), _c('img', {
    staticClass: "flex-people",
    attrs: {
      "src": require("../../assets/images/confirmOrder/flex-people.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "product flex"
  }, [_c('div', {
    staticClass: "left shopwindow-svg"
  }), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('div', [_c('div', {
    staticClass: "chuchuang"
  }, [_vm._v("手机橱窗")]), _vm._v(" "), _c('span', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "zhe"
  }, [_vm._v("折")]), _vm._v(" "), _c('span', {
    staticClass: "zhe-bg"
  }, [_vm._v("7折优惠")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("能卖货")]), _vm._v(" "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("能获客")]), _vm._v(" "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("高性价比")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex info-bottom"
  }, [_c('span', {
    staticClass: "grey-bottom"
  }, [_vm._v("已选：终身版")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "grey-bottom delline"
  }, [_vm._v("¥1245")]), _vm._v(" "), _c('span', {
    staticClass: "orange-bottom"
  }, [_vm._v("¥"), _c('span', [_vm._v("4288")])])])])])]), _vm._v(" "), _c('c-cell-container', [_vm._l((_vm.payTypeGroup), function(item, index) {
    return _c('c-cell-checkbox', {
      key: index,
      class: {
        'disabled': item.isAvailable
      },
      attrs: {
        "value": item.isChecked,
        "point": false
      },
      on: {
        "input": function (val) { return _vm.checkChange(val, item); }
      }
    }, [_c('div', {
      staticClass: "goods-icon",
      slot: "header"
    }, [_c('img', {
      staticClass: "payoff-img",
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ml-5 text-elps goods-desc",
      slot: "body"
    }, [_c('div', [_vm._v(_vm._s(item.name))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "stages flex"
  }, _vm._l((_vm.payStagesGroup), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col",
      class: {
        'active': item.isChecked
      },
      on: {
        "click": function($event) {
          _vm.handleStages(index)
        }
      }
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.NumberName))]), _vm._v(" "), _c('div', {
      staticClass: "commission"
    }, [_vm._v("手续费" + _vm._s(item.commission))])])
  }))], 2)], 1), _vm._v(" "), _c('c-footer', [_c('div', {
    staticClass: "footer flex"
  }, [_c('div', {
    staticClass: "left-info flex"
  }, [_c('span', {
    staticClass: "gold"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¥")]), _c('span', {
    staticClass: "big"
  }, [_vm._v("3288")])]), _vm._v(" "), _c('span', {
    staticClass: "gold small delline"
  }, [_vm._v("¥3687")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "gold small"
  }, [_vm._v("省")]), _vm._v(" "), _c('span', {
    staticClass: "red small"
  }, [_vm._v("¥399")])])]), _vm._v(" "), _c('div', {
    staticClass: "payoff-button"
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("确认支付")]), _vm._v(" "), _c('div', {
    staticClass: "button-bg"
  })])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-159b10f7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ConfirmOrder/index.vue
// module id = 1021
// module chunks = 2